//import saveAs from 'file-saver';

import { testForGrid } from '../../../spd/components/Tests/Tests';
import { DefaultApi } from '../autogenerated/spdApiClient/apis/DefaultApi';
import { GetTestDto } from '../autogenerated/spdApiClient/models/GetTestDto';
import {
  CreateUpdateTestDto,
  CreateUpdateTestDtoFromJSON,
} from '../autogenerated/spdApiClient';
import { validateAgainst } from '../validation/validateAgainst';
import { TestSchema } from '../validation/schemas';
import { GridRecord } from '../../components/Grid/GridDataTypes';

export type TestEntity = GetTestDto;

export interface TestContextInterface {
  getTest: (id: string) => Promise<TestEntity>;
  getAllByPortion: (
    withNotActive: boolean,
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    showMonitorButton?: boolean,
  ) => Promise<GridRecord[]>;
  getAllCount: (withNotActive: boolean, filterText?: string) => Promise<number>;
  getAll: () => Promise<GetTestDto[]>;
  getAllForSelector: (
    text: string,
  ) => Promise<{ label: string; value: string }[]>;
  getIdsByBattery: (id: string) => Promise<string[]>;
  getByIdentifier: (identifier: string) => Promise<TestEntity>;
  update: (id: string, dto: CreateUpdateTestDto) => Promise<void>;
  create: (dto: CreateUpdateTestDto) => Promise<GetTestDto>;
}

export const TestContext = (api: DefaultApi) => {
  return {
    getTest: async (id: string) => {
      return await api.testControllerGet(id);
    },

    getAllByPortion: async (
      withNotActive: boolean,
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      showMonitorButton?: boolean,
    ) => {
      const data = await api.testControllerGetAllByPortion(
        withNotActive,
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
      );
      return data.map(test => testForGrid(test, showMonitorButton));
    },

    getAllCount: (withNotActive: boolean, filterText?: string) =>
      api.testControllerGetAllCount(withNotActive, filterText || ''),

    getAll: () => api.testControllerGetAll(),
    getAllForSelector: async (text: string) => {
      const data = await api.testControllerGetAllByName(text);

      return Array.from(data, test => {
        return {
          value: test.id,
          label: test.name || '',
        };
      });
    },

    getIdsByBattery: (id: string) => api.testControllerGetByBattery(id),

    getByIdentifier: (identifier: string) =>
      api.testControllerGetByIdentifier(identifier),

    update: (id: string, dto: CreateUpdateTestDto) =>
      api.testControllerUpdate(id, dto),

    create: (dto: CreateUpdateTestDto) => api.testControllerCreate(dto),
  };
};

export const validate = (test: CreateUpdateTestDto) => {
  //export const validate = (test: CreateUpdateTestDto, id?: string) => {
  // if (!id) {
  //   return validateAgainst(TestSchemaInsert, test);
  // } else {
  return validateAgainst(TestSchema, test);
  //}
};

export const testData = (test?: GetTestDto): CreateUpdateTestDto => {
  return CreateUpdateTestDtoFromJSON({
    ...test,
  });
};
